import { useState, ChangeEvent, useCallback, useMemo } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/OccupationSelectModal/logics/createOccupationDisplayData';
import { EmploymentStatusListType } from 'types/employmentStatus';
import { HooksArgument } from 'components/SearchSideBar/types';
import { createInitialEmploymentStatusList } from '../../logics/createInitialEmploymentStatusList';

/**
 * 雇用形態に関するhooks
 * @param args
 * @returns 表示用配列と更新処理
 */
export const useEmploymentStatus = (args: HooksArgument) => {
  const [employmentStatusList, setEmploymentStatusList] = useState<
    EmploymentStatusListType[]
  >(createInitialEmploymentStatusList(args));

  // 選択中の条件
  const selectedEmploymentStatusIdList = useMemo(() => {
    return employmentStatusList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  }, [employmentStatusList]);

  // チェック状態更新処理
  const updateIsCheckEmploymentStatusList = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const checkedList = employmentStatusList.map((employmentStatus) => {
        if (employmentStatus.value !== event.target.value)
          return employmentStatus;

        return {
          ...employmentStatus,
          isChecked: event.target.checked,
        };
      });

      setEmploymentStatusList(checkedList);

      return checkedList
        .filter(({ isChecked }) => isChecked)
        .map(({ value }) => value);
    },
    [employmentStatusList]
  );

  // 求人件数更新処理
  const updateEmploymentStatusListJobCount = useCallback(
    (employmentStatusJobCountList: JobCountDetailResponse[] | undefined) => {
      setEmploymentStatusList((pre) =>
        pre.map((employmentStatus) => {
          return {
            ...employmentStatus,
            jobCount: findJobCount(
              employmentStatusJobCountList,
              employmentStatus.value
            ),
          };
        })
      );
    },
    []
  );

  return {
    employmentStatusList,
    selectedEmploymentStatusIdList,
    updateIsCheckEmploymentStatusList,
    updateEmploymentStatusListJobCount,
  };
};
